"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NethoneDetails = void 0;
class NethoneDetails {
    inquiryId = null;
    feedbackId = null;
    fraudAdvice = null;
}
exports.NethoneDetails = NethoneDetails;
//# sourceMappingURL=NethoneDetails.js.map